import React from 'react';
import { Link } from 'react-router-dom';
import routes from '../../constants/routes';

export const AccountMigrate = ({ username }) => (
    <div className="signup-success__container">
        <div className="signup-success__body">
            <div className="signup-success">
                <i className="fa fa-envelope-open-o fa-3" aria-hidden="true" />
                <div className="copy">
                    <h1>Check your email to update your password</h1>
                    <p>
                        <strong>An activation email has been sent to {username}.</strong>
                        <small>
                            We’ve made some improvements and need you to set up your account again.
                            Please check your email and follow the link to set a password.
                        </small>
                    </p>
                    <Link to={routes.SIGNUP}>Don’t have an account? Sign-up here</Link>
                </div>
            </div>
        </div>
    </div>
);
